import React from 'react';
export function Hero() {
  return <section className="bg-gradient-to-b from-black to-gray-900 text-white py-16 md:py-24" data-id="element-223">
      <div className="container mx-auto px-4" data-id="element-224">
        <div className="max-w-5xl mx-auto" data-id="element-225">
          <div className="mb-8 text-center" data-id="element-226">
            <span className="bg-blue-800 text-white px-3 py-1 rounded-md text-sm font-medium" data-id="element-227">
              HEALTH INVESTIGATION
            </span>
            <p className="text-gray-400 mt-2 text-sm" data-id="element-228">
              Published:{' '}
              {new Date().toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
            </p>
          </div>
          <div className="text-center md:text-left" data-id="element-229">
            <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight font-serif" data-id="element-230">
              THE ANCIENT SECRET BIG PHARMA DOESN'T WANT YOU TO KNOW ABOUT YOUR
              VANISHING MASCULINE DRIVE
            </h1>
            <div className="w-24 h-1 bg-blue-600 mx-auto md:mx-0 mb-6" data-id="element-231"></div>
            <p className="text-lg md:text-xl mb-8 text-gray-300" data-id="element-232">
              What if I told you that the same companies making billions from
              your low testosterone are the ones who buried the natural solution
              that could fix it?
            </p>
            <div className="my-12" data-id="element-233">
              <img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Man with restored vitality" className="rounded-lg shadow-xl w-full h-auto max-w-3xl mx-auto" data-id="element-234" />
              <p className="text-sm text-gray-400 mt-2 italic text-center" data-id="element-235">
                Men across the country are discovering this ancient secret to
                restore their vitality
              </p>
            </div>
            <p className="text-lg md:text-xl mb-12 text-gray-300" data-id="element-236">
              And what if this solution has been hiding in plain sight for over
              1,000 years?
            </p>
          </div>
        </div>
      </div>
    </section>;
}